import { Record } from 'immutable';

import type { QcsSyncResourceStore } from '../core/resourceStoreTypes';
import type { Security, SecurityProps } from '../securities/securitiesTypes';

export const INVESTMENT_SYMBOLS_KEY = 'investmentSymbolsStore';

export type InvestmentSymbolProps = {
  exchange?: string;
  id?: string;
  name: string;
  security?: Security | SecurityProps;
  symbol: string;
};

export type InvestmentSymbolsStore = QcsSyncResourceStore<InvestmentSymbolProps>;

export const mkInvestmentSymbol = Record<InvestmentSymbolProps>({
  exchange: undefined,
  id: undefined,
  name: undefined!,
  security: undefined,
  symbol: undefined!,
});
